var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 91,
    viewBox: "0 0 90 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45.75,
    r: 45,
    fill: "#CFF1FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.8407 48.1416C55.697 48.1416 59.7001 52.1447 59.7001 57.001V59.6916C59.7001 61.4635 58.2563 62.8416 56.5501 62.8416H33.4501C31.6782 62.8416 30.3001 61.4635 30.3001 59.6916V57.001C30.3001 52.1447 34.2376 48.1416 39.0938 48.1416C40.997 48.1416 41.8501 49.1916 45.0001 49.1916C48.0845 49.1916 48.9376 48.1416 50.8407 48.1416ZM57.6001 59.6916V57.001C57.6001 53.2604 54.5813 50.2416 50.8407 50.2416C49.5938 50.2416 48.2813 51.2916 45.0001 51.2916C41.6532 51.2916 40.4063 50.2416 39.0938 50.2416C35.3532 50.2416 32.4001 53.2604 32.4001 57.001V59.6916C32.4001 60.2822 32.8595 60.7416 33.4501 60.7416H56.5501C57.0751 60.7416 57.6001 60.2822 57.6001 59.6916ZM45.0001 46.0416C40.3407 46.0416 36.6001 42.301 36.6001 37.6416C36.6001 33.0478 40.3407 29.2416 45.0001 29.2416C49.5938 29.2416 53.4001 33.0478 53.4001 37.6416C53.4001 42.301 49.5938 46.0416 45.0001 46.0416ZM45.0001 31.3416C41.522 31.3416 38.7001 34.2291 38.7001 37.6416C38.7001 41.1197 41.522 43.9416 45.0001 43.9416C48.4126 43.9416 51.3001 41.1197 51.3001 37.6416C51.3001 34.2291 48.4126 31.3416 45.0001 31.3416Z",
    fill: "#0097DF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserLogo);
export default __webpack_public_path__ + "static/media/user-logo.372df2578b8d63c0324fb66284496781.svg";
export { ForwardRef as ReactComponent };